











import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class RadioButtonBox extends Vue {
  @Prop() value!: string;
  @Prop() model!: string;
  @Prop() name!: string;
  @Prop({ default: false }) disabled!: boolean;
  /**
   * Additive only. Callers that need a tile geometry other than the shared
   * 150px box (BaseSelector's 200x48 tiles, from the FUPOF-193 XD) pass their
   * own class here rather than changing `.radio-btn`, which is used on every
   * configurator screen. Vue 2 stamps the parent's scoped `data-v-` attribute
   * onto this component's root `<button>`, so a class styled in the caller's
   * scoped block does reach it.
   */
  @Prop({ type: String, default: "" }) boxClass!: string;

  public onClick(): void {
    if (this.disabled) return;
    this.updateItem(this.value, "model");
  }

  public updateItem(fieldValue: string, fieldName: string) {
    this.$emit(`update:${fieldName}`, fieldValue);
  }
}
